import React from "react";
import { useSelector } from "react-redux";
import TheHeader from "../comm/inCar/TheHeader";
import TheNav from "../comm/inCar/TheNav";
import TheFooter from "../comm/inCar/TheFooter";
import {
  CButton,
  CContainer,
  CFormGroup,
  CCardBody,
  CInputRadio,
  CInputCheckbox,
  CLabel,
  CCollapse,
  CCol,
} from "@coreui/react";
import Swal from "sweetalert";
import ApiHelper from "src/utils/api/api_helper";

const AgreePage = () => {
  const state = useSelector((state) => state.main);
  const [accordion, setAccordion] = React.useState(0);
  const [sEncData, setSEncData] = React.useState("");
  const [isChecked, setIsChecked] = React.useState(false);
  const [agree, setAgree] = React.useState([false, false, false]);

  const toggleChange = () => {
    let _agree = [];

    if (!isChecked) {
      _agree = agree.map(() => {
        return true;
      });
    } else {
      _agree = agree.map(() => {
        return false;
      });
    }

    setAgree(_agree);
    setIsChecked(!isChecked);
  };

  const _toggleChange = (chagneAgree) => {
    if (!chagneAgree.includes(false)) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  };

  const changeRadio = (e) => {
    let _changeAgree = [];
    switch (e.target.name) {
      case "agree1":
        _changeAgree = agree.map((item, index) => {
          if (index === 0) {
            if (!item) {
              setAccordion(1);
            }
            return !item;
          } else {
            return item;
          }
        });
        _toggleChange(_changeAgree);
        return setAgree(_changeAgree);
      case "agree2":
        _changeAgree = agree.map((item, index) => {
          if (index === 1) {
            if (!item) {
              setAccordion(2);
            }
            return !item;
          } else {
            return item;
          }
        });
        _toggleChange(_changeAgree);
        return setAgree(_changeAgree);
      case "agree3":
        _changeAgree = agree.map((item, index) => {
          if (index === 2) {
            if (!item) {
              setAccordion(null);
            }
            return !item;
          } else {
            return item;
          }
        });
        _toggleChange(_changeAgree);
        return setAgree(_changeAgree);
      default:
        break;
    }
  };

  const checkAgree = () => {
    if(!state.taskNo) {
      return Swal(
        "",
        "올바른 접근이 아닙니다. 처음으로 돌아가 업무선택부터 진행해주세요.",
        "error"
      );
    }
    if (!agree[0])
      return Swal(
        "",
        "제휴 보험회사별 위촉서류 작성을 위한 개인(신용)정보 제공 동의는 필수입니다.",
        "error"
      );
    if (!agree[1])
      return Swal("", "부실작성에 따른 조치 동의는 필수입니다.", "error");
    if (!agree[2])
      return Swal(
        "",
        "easyPaper 사용에 대한 개인정보 보호약관 동의는 필수입니다.",
        "error"
      );

    // 본인인증으로 이동
    document.form_chk.action =
      "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
    document.form_chk.submit();
  };

  React.useEffect(() => {
    let params = {
      corpNm: state.corpNm,
      corpNo: state.corpNo,
      taskNo: state.taskNo,
    };
    ApiHelper.request(ApiHelper.methods.get, "/nice/encrypt/data", params)
      .then(({ data }) => {
        //encode data
        setSEncData(data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={state.step} />
        <CContainer>
          <h5>
            <b>보험사별 위촉서류 작성을 위한 사전 동의</b>
          </h5>
        </CContainer>
        <article className="ui-check">
          <div className="component-checkbox">
            <label>
              <input 
                type="checkbox" 
                id="allAgree"
                name="allAgree"
                onChange={toggleChange}
                checked={isChecked} 
              />
              <i />
              <span className="txt-label">모두동의</span>
            </label>
          </div>
        </article>
        <CCardBody className="bottom-card-body agree-card-body">
          <div id="accordion">
            <CCol className="agreeCol mb-2">
              <CButton
                block
                color=""
                variant="outline"
                className="text-left m-0 p-0"
                onClick={() => setAccordion(accordion === 0 ? null : 0)}
              >
                <p className="m-0 p-0">
                제휴 보험회사별 위촉서류 작성을 위한 개인(신용)정보 제공 동의<b>(클릭)</b>
                </p>
              </CButton>
            </CCol>
            <CCollapse show={accordion === 0}>
              <CCardBody className="text-left agreeBody">
                본인은 `인카다이렉트(주)` 제휴 보험회사별 위촉양식을 작성함
                있어 본 페이지의 항목을 작성하여 제출시 본인의 개인(신용)정보
                (성명,주민번호,생년월일,전화번호,전자우편주소,자택주소)가 귀사의
                제휴 보험회사로 코드위촉을 위한 목적으로 제출되는 것을 동의
                합니다.<br></br> [제휴 보험회사]<br></br> 손해보험: 메리츠화재<br></br>
                생명보험: 미래에셋생명, 한화생명, DB생명, KDB생명, 삼성생명, 교보생명,
                DGB생명, 신한라이프, 흥국생명, ABL생명, KB라이프생명, IBK연금보험, NH농협생명,
                메트라이프생명, 처브라이프생명<br></br> *
                자필위촉서류가 필요한 보험사는 양식을 인사담당자에게 받아
                자필작성 하신 후 원본서류를 제출하시기 바랍니다.
              </CCardBody>
            </CCollapse>
            <CCol className="text-right mt-2 mb-2">
              <CFormGroup variant="custom-radio" inline>
                <CInputRadio
                  custom
                  id="agree1Yes"
                  name="agree1"
                  checked={agree[0] ? true : false}
                  onChange={changeRadio}
                />
                <CLabel variant="custom-checkbox" htmlFor="agree1Yes">
                  동의함
                </CLabel>
              </CFormGroup>
              <CFormGroup variant="custom-radio" inline>
                <CInputRadio
                  custom
                  id="agree1No"
                  name="agree1"
                  checked={!agree[0] ? true : false}
                  onChange={changeRadio}
                />
                <CLabel variant="custom-checkbox" htmlFor="agree1No">
                  동의하지 않음
                </CLabel>
              </CFormGroup>
            </CCol>
            <CCol className="agreeCol mb-2">
              <CButton
                block
                color=""
                variant="outline"
                className="text-left m-0 p-0"
                onClick={() => setAccordion(accordion === 1 ? null : 1)}
              >
                <p className="m-0 p-0">
                  부실작성에 따른 조치 동의<b>(클릭)</b>
                </p>
              </CButton>
            </CCol>
            <CCollapse show={accordion === 1}>
              <CCardBody className="text-left agreeBody">
                본인은 모바일 위촉양식을 작성함에 있어 본인이 직접 작성하였음을
                확인하며, 본인이 아닌 타인이 대리작성 하거나, 작성 내용의 허위,
                입력오류, 누락 등으로 인하여 위촉계약 결격사유 발생 또는 제휴
                보험회사별 위촉반려 등이 발생하는 경우 본인이 모든 책임을 감수
                하겠으며, 이를 방지하기 위하여 본인이 정확한 입력정보를 작성할
                것을 동의 합니다.
              </CCardBody>
            </CCollapse>
            <CCol className="text-right mt-2 mb-2">
              <CFormGroup variant="custom-radio" inline>
                <CInputRadio
                  custom
                  id="agree2Yes"
                  name="agree2"
                  checked={agree[1] ? true : false}
                  onChange={changeRadio}
                />
                <CLabel variant="custom-checkbox" htmlFor="agree2Yes">
                  동의함
                </CLabel>
              </CFormGroup>
              <CFormGroup variant="custom-radio" inline>
                <CInputRadio
                  custom
                  id="agree2No"
                  name="agree2"
                  checked={!agree[1] ? true : false}
                  onChange={changeRadio}
                />
                <CLabel variant="custom-checkbox" htmlFor="agree2No">
                  동의하지 않음
                </CLabel>
              </CFormGroup>
            </CCol>
            <CCol className="agreeCol mb-2">
              <CButton
                block
                color=""
                variant="outline"
                className="text-left m-0 p-0"
                onClick={() => setAccordion(accordion === 2 ? null : 2)}
              >
                <p className="m-0 p-0">
                  EasyPaper 이용에 따른 정보이용 동의<b>(클릭)</b>
                </p>
              </CButton>
            </CCol>
            <CCollapse show={accordion === 2}>
              <CCardBody className="text-left agreeBody">
                계약업체의 온라인 서류처리를 위한 목적으로 아래와 같이
                개인정보를 제공하고 있으며, 관계 법령에 따라 위탁 계약 시 개인
                정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고
                있습니다.<br></br> 제공받는 자 및 위탁하는 업무 내용<br></br>{" "}
                업체명 : 주식회사 에이전시프로<br></br> 연락처 : 02-582-1570
                <br></br> EasyPaper 서비스로 보험사별 위촉서류 등
                계약사의 온라인 서류처리를 위한 요청 위 서비스를 위해 정보제공에
                동의합니다.
              </CCardBody>
            </CCollapse>
            <CCol className="text-right mt-2">
              <CFormGroup variant="custom-radio" inline>
                <CInputRadio
                  custom
                  id="agree3Yes"
                  name="agree3"
                  checked={agree[2] ? true : false}
                  onChange={changeRadio}
                />
                <CLabel variant="custom-checkbox" htmlFor="agree3Yes">
                  동의함
                </CLabel>
              </CFormGroup>
              <CFormGroup variant="custom-radio" inline>
                <CInputRadio
                  custom
                  id="agree3No"
                  name="agree3"
                  checked={!agree[2] ? true : false}
                  onChange={changeRadio}
                />
                <CLabel variant="custom-checkbox" htmlFor="agree3No">
                  동의하지 않음
                </CLabel>
              </CFormGroup>
            </CCol>
          </div>
        </CCardBody>
        <form name="form_chk">
          <input type="hidden" name="m" value="checkplusService" />
          <input type="hidden" name="EncodeData" value={sEncData} />
        </form>
      </div>
      <TheFooter step={state.step} handleCheckAgree={checkAgree} />
    </>
  );
};

export default AgreePage;
